<template>
  <div class="filter-content">

    <h5>Vehicle Make</h5>
    <select @change="onBrandChange()" v-model="filterModel.brandId" :disabled="!brands.length || !isLoaded">
      <option :value="null">All Makes</option>
      <option v-for="brand in brands" :key="brand.id" :value="brand.id">{{brand.name}}</option>
    </select>

    <h5>Vehicle Model</h5>
    <select @change="onModelChange()" v-model="filterModel.modelId" :disabled="!models.length || !isLoaded">
      <option :value="null">All Models</option>
      <option v-for="model in models" :key="model.id" :value="model.id">{{model.name}}</option>
    </select>

    <h5>Vehicle Trim</h5>
    <select @change="onTrimChange()" v-model="filterModel.trim" :disabled="!trims.length || !isLoaded">
      <option :value="null">All Trims</option>
      <option v-for="(trim,key) in trims" :key="key" :value="trim">{{trim}}</option>
    </select>

    <h5>Vehicle Year</h5>
    <range-slider :id="'years-range'" class="filter-slider" :minRange="yearRange.from" :maxRange="yearRange.to"
      :minValue="years.from"
      :maxValue="years.to" 
      :limit="years.from !== years.to ? yearLimit : null" 
      :step="yearStep"
      @change="onYearsChanged" :disabled="!isLoaded" />

    <h5>Vehicle Price</h5>
    <range-slider :id="'price-range'" class="filter-slider" :minRange="priceRange.from" :maxRange="priceRange.to"
      :minValue="price.from"
      :maxValue="price.to" 
      :allowSameValues="false" 
      :limit="priceLimit"
      :step="priceStep" @change="onPriceChanged" :disabled="!isLoaded" />

    <h5>Vehicle Body</h5>
    <select @change="onBodyChange()" v-model="filterModel.body" :disabled="!bodies.length || !isLoaded">
      <option :value="null">All Bodies</option>
      <option v-for="(body,key) in bodies" :key="key" :value="body">{{body}}</option>
    </select>

    <div class='buttons'>
      <div v-show="!isLoaded" class="loader">
        <loader :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
      </div>

      <button v-show="isLoaded" @click="resetAndSearch()">
        <img src='../../assets/icons/black/menu_close.png'> <span>RESET SEARCH</span>
      </button>

      <button class="active" v-show="isLoaded" @click='search()'>
        <span>SHOW RESULT</span>
      </button>
    </div>

    <div v-if='!isLoaded' class='loader-container' color="#f9f300">
      <loader :animation-duration="2500" :rhombus-size="25" color="#f9f300" />
    </div>

  </div>
</template>
<script>
  import {
    LoopingRhombusesSpinner
  } from 'epic-spinners'
  import RangeSlider from '../range-slider'
  import filterCoreMixin from '@/mixins/vauto.filter.mixin.js'
  export default {
    name: 'vauto-filter',
    components: {
      'loader': LoopingRhombusesSpinner,
      RangeSlider
    },
    props: {
      loading: {
        type: Boolean
      }
    },
    mixins: [filterCoreMixin],
    created: async function () {
      await this.loadFilterData(this.filterModel)

      // this.initPriceRanges()
      // this.initYearsRanges()
      this.isLoaded = true
    },
    watch: {
      loading (val) {
        this.isLoaded = !val
      }
    },
    methods: {
      async resetAndSearch () {
        this.resetFilterModel()
        this.$emit('search')
        this.isLoaded = false
        await this.loadFilterData(this.filterModel)
        // this.initPriceRanges()
        // this.initYearsRanges()
        this.isLoaded = true
      },
      async search () {
        this.$emit('search')
      }
    }
  }
</script>
<style scoped>
  .filter-content {
    position: relative;
  }

  .filter-slider {
    margin-bottom: 15px;
    padding: 0 15px;
  }

  .button_full {
    margin-top: 20px
  }

  select {
    width: 100%;
    height: 35px;
    font-size: 18px;
    padding-left: 5px;
  }

  h5 {
    font-weight: bold;
    padding: 10px 0 10px 0;
  }

  .select-left {
    width: 45%;
    float: left;
    display: block;
  }

  .select-right {
    width: 45%;
    float: right;
    display: block;
  }

  button {
    background-color: #fff;
    border: none;
    margin-top: 20px;
  }

  button span {
    font-weight: bold;
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 25px;
  }
  .buttons > button{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
  }
  .buttons > button.active{
    background-color: #000;
    color: #fff;
  }
  .buttons > button> img{
    height: 20px;
    margin-right: 10px;
  }

  .loader-container {
    position: absolute;
    height: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: rgba(255, 255, 255, 0.38);
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// vauto-filter.vue?dcdcdf86